import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Layout from "@/components/layout/Layout";
import ScrollToTop from "@/components/layout/ScrollToTop";
import SmoothScroll from "@/components/layout/SmoothScroll";
import { LeadDialogProvider } from "@/context/LeadDialogContext";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ServicesHub from "@/pages/ServicesHub";
import ServiceDetail from "@/pages/ServiceDetail";
import IndustriesHub from "@/pages/IndustriesHub";
import IndustryDetail from "@/pages/IndustryDetail";
import BlogHub from "@/pages/BlogHub";
import BlogPost from "@/pages/BlogPost";
import GlossaryHub from "@/pages/GlossaryHub";
import GlossaryTerm from "@/pages/GlossaryTerm";
import ToolsChecker from "@/pages/ToolsChecker";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <LeadDialogProvider>
          <Routes>
            <Route path="/" element={withLayout(<Home />)} />
            <Route path="/about" element={withLayout(<About />)} />
            <Route path="/contact" element={withLayout(<Contact />)} />
            <Route path="/services" element={withLayout(<ServicesHub />)} />
            <Route path="/services/:slug" element={withLayout(<ServiceDetail />)} />
            <Route path="/industries" element={withLayout(<IndustriesHub />)} />
            <Route path="/industries/:slug" element={withLayout(<IndustryDetail />)} />
            <Route path="/blog" element={withLayout(<BlogHub />)} />
            <Route path="/blog/:slug" element={withLayout(<BlogPost />)} />
            <Route path="/glossary" element={withLayout(<GlossaryHub />)} />
            <Route path="/glossary/:slug" element={withLayout(<GlossaryTerm />)} />
            <Route path="/tools" element={withLayout(<ToolsChecker />)} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={withLayout(<NotFound />)} />
          </Routes>
        </LeadDialogProvider>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
